import React from "react";
import withRouter from "../withRouter";
import { connect } from "react-redux";
import { logout } from "../store/actions/auth";
import AssignRegionDlg from "../components/AssignRegionDlg";
import FilterDlg from "../components/FilterDlg";
import AccessDenyDlg from "../components/AccessDenyDlg";

import "../styles/Layout.scss"
import Sidebar from "../components/Sidebar";

class CustomLayout extends React.Component {

  state = {
  }

  render() {
    const { authenticated } = this.props;
    return (
      <div className="layout-container">
        <div style={{ display: 'flex' }}>
          {
            authenticated && 
            <Sidebar />
          }
          <div className="right-wrapper">
            <div className="right-content">
              <div className="right-content-main">
                {this.props.children}
              </div>
            </div>
            <div className="footer-div">
              {authenticated ? <ul>
                <li>Help</li>
                <li onClick={()=>this.props.navigate("/settings")}>Settings</li>
                <li onClick={()=>this.props.navigate("/privacy-policy")}>Privacy Policy</li>
                <li onClick={()=>this.props.navigate("/terms-condition")}>Terms & Condition</li>
              </ul> : <ul>
                <li onClick={()=>this.props.navigate("/privacy-policy")}>Privacy Policy</li>
                <li onClick={()=>this.props.navigate("/terms-condition")}>Terms & Condition</li></ul>}
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <p>
                  Developed By Vibtech Genesis
                </p>
                <p>
                  2025 Vibtech Genesis Pte Ltd
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <AssignRegionDlg />
        <FilterDlg />
        <AccessDenyDlg /> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authenticated: state.auth.token !== null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logout())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CustomLayout)
);
